import * as React from "react";
import cx from "classnames";
import {  uniqueId } from 'lodash';
import { Text, TranslationsProvider } from '@eo-locale/react';
import '@blueprintjs/core/lib/css/blueprint.css';
import { Tree, Classes, Intent } from "@blueprintjs/core";
import { Button,Switch, Card, Elevation,Icon, Overlay,H4 } from "@blueprintjs/core";
import { Checkbox } from '@material-ui/core';
import  {MSG_VISIO} from "../MessagesVisio.js"
import axios from 'axios'


//import { Example } from '@blueprintjs/docs-theme';
//import { DialogExample } from './components/dialogExample';
import {
  Alignment,
  H5,
  Navbar,
  Toast,
  NavbarDivider,
  NavbarGroup,
  NavbarHeading,
  Toaster,
  Position,
  Code,
    MultistepDialog,
    DialogStep,
    ButtonProps,
    RadioGroup,
    Radio,
    NumericInput,
    Label,
} from "@blueprintjs/core";
import PanelNom from './PanelNom.tsx';
import PanelEmail from './PanelEmail.tsx';
import PanelPassword from './PanelPassword.tsx';
import PanelOnePassword from './PanelOnePassword.tsx';
import MyToaster from './components/MyToaster.tsx';
import CardMesEnregistrementsEnseignants from './CardMesEnregistrementsEnseignants.tsx'
import { type, userInfo } from "os";
import { throws } from "assert";
import CardFonctions from "./CardFonctions.tsx";
import CardFonctionsIndividuelles from "./CardFonctionsIndividuelles.tsx";
import CardVisioMagistrale from "./CardVisioMagistrale.tsx";
import CardForceMatiere from "./CardForceMatiere.tsx";
import { INTENT_DANGER } from "@blueprintjs/core/lib/esm/common/classes";

export type type_home = {
value:undefined,
isValidSignin:undefined,
isValidLogin:undefined
}
let fenetreOuverte;
let fenetreOuvertemosaique;
export default class CardMesEleves extends React.Component  <{}> {
 // class_selected=Classes.OUTLINED+" "+ Classes.LARGE +" "+ Classes.INTENT_SUCCESS;
 // class_noselected=Classes.OUTLINED+" "+ Classes.LARGE +" "+ Classes.INTENT_WARNING;
 visio_prof=[]; 
 msg_visio=MSG_VISIO;
  state = {
    name: '',
    dcnx:false,
    selected_mesdocuments:false,
    lstStudent:false,
    selected_visio:false,
    selected_reduire:640,
    nb_student:0,
    must_refresh:false,
    datastudent:[],
    selected_student:[{}],
    classevide: [],
    uneclasse: [],
    isOpenHelp:false,
    selected_classe:'',
    isconfirmdeleteclasse:false,
    isedit:false,
    selected_classe_edit:'',
    isSelectedClasse:false,
    eleve_seleted_toerase_pwd:-1,
    loadeddata:false,
    selected_classe_id:"",
    isvisibleenregistrements:false,
    isvisiblegroupes:false,
    conference:{selected:false,objtabid:[],groupes:[],ID:-1},
    recordaudio:{selected:false,objtabid:[],groupes:[],ID:-1},
    mosaique:{selected:false,objtabid:[],groupes:[],ID:-1},
    isOpenHelpGroupe:false,
    isvisiomagistrale:false,
    datamatieres:this.props.datamatieres,
    isSelectMatiere:false,
    select_matiere_id:1,
    eleve_selected_todocument:-1,
    eleve_selected_intercommunication:-1,
    eleve_selected_ecoutediscrete:-1,
    isvisibleindividuel:false,
    intercommunication:false,
    ecoutediscrete:false,
    eleve_selected_visuecran:"",
    // classes:[{nom:"maclasse"},{nom:"une autre classe"},{nom:"encore une autre classe"}]
    classes:[]
  }  
  

  constructor(props) {
        super(props);
        
       // this.handleChange = this.handleChange.bind(this);
      }
  componentDidMount () { 
    console.log(this.props);
    this.setState({nb_student:this.props.nb_student_cnx})
    var obj=[];
    var obj2=[];
    var obj3=[];
    this.props.datastudent.map((item)=>{obj2.push(item)});
    obj2.sort((a,b)=>{if(a.nickname.toLowerCase() < b.nickname.toLowerCase()) return -1;
        if(a.nickname.toLowerCase() > b.nickname.toLowerCase()) return 1;
        return 0;}).map((item, idx)=>{
      var item2=item;
      item.selected=false;
      
      //item2.selected=true;
      //if(item.status=="connected")item.selected=true;
      if(item2.etat=="En ligne") {item2.selected=true;obj.push(item2) ;}
      if(item.nickname!=undefined)if(item.nickname!="")obj3.push(item);
     });
     this.setState({selected_student:obj});
     this.setState({datastudent:obj3});
     var st=localStorage.getItem("select_matiere_id");
     if(st!="")this.setState({select_matiere_id:st}); 
     this.setState({datamatieres:this.props.datamatieres})
     
    
  }
  
  componentDidUpdate(prevProps, prevState) {
   
   if(this.props.datamatieres!=this.state.datamatieres)this.setState({datamatieres:this.props.datamatieres});
   if(!this.state.loadeddata)
   {
       this.setState({loadeddata:true}); 
       this.LoadDataClassesForEnseignant(this.props.userid);
       
    }
   if(this.props.nb_student_cnx!=this.state.nb_student)
   {
    this.setState({nb_student:this.props.nb_student_cnx})
    var obj=[];
    var obj2=[];
    var obj3=[];
    this.props.datastudent.map((item)=>{obj2.push(item)});
    obj2.sort((a,b)=>{if(a.nickname.toLowerCase() < b.nickname.toLowerCase()) return -1;
        if(a.nickname.toLowerCase() > b.nickname.toLowerCase()) return 1;
        return 0;}).map((item, idx)=>{
      var item2=item;
      //item2.selected=true;
      item2.selected=false;
      if(item2.etat=="En ligne") {item2.selected=true;obj.push(item2) ;}
      ////if(item.status=="connected")item.selected=true;
      if(item.nickname!=undefined)if(item.nickname!="")obj3.push(item);
     });
     this.setState({selected_student:obj});
     this.setState({datastudent:obj3});
     
   }
   if(this.state.must_refresh==true) 
   {
       this.setState({must_refresh:false});
       this.props.handleDataClasseEtudiants(this.state.classes);
       var st=localStorage.getItem("selected_classe_id");
       if(st != this.state.selected_classe_id.toString()) this.state.classes.filter((it)=>it.ID==st).map((item)=>this.handlePublicChange(item));
       
   }
  }

onDragStart = (ev, id) => {
    console.log('dragstart:',id);
    ev.dataTransfer.setData("id", id);
}

onDragOver = (ev) => {
    ev.preventDefault();
}
DeleteFromGroupe=(id)=>
{
    this.state.classes.filter((it)=>it.ID==this.state.selected_classe_id).map((itemclasse)=>
    {
        itemclasse.groupe.map((itemgroupe)=>{
           
                var objgroupestudent=[]    ;
                itemgroupe.groupestudent.map((it2)=>{
                    if (it2.id_student!=id)objgroupestudent.push(it2);
                })
                itemgroupe.groupestudent=objgroupestudent;
        });
    }
    );
    this.setState({must_refresh:true});
}
onDropGroup=(ev, cat) => {
    
    let id = ev.dataTransfer.getData("id");
    console.log(id);
    console.log(cat);
    this.state.classes.filter((it)=>it.ID==this.state.selected_classe_id).map((itemclasse)=>
    {
        itemclasse.groupe.map((itemgroupe)=>{
            if(itemgroupe.nom==cat)
            {
                var objgroupestudent=[]    ;
                itemgroupe.groupestudent.map((it2)=>{
                    if (it2.id_student!=id)objgroupestudent.push(it2);
                })
                var stnomstudent="";
                this.state.datastudent.map((itemstudent)=>
                {
                    if(itemstudent.ID==id) stnomstudent=itemstudent.nickname;
                });
                var st={id_student:id, nom:stnomstudent};
                objgroupestudent.push(st);
                itemgroupe.groupestudent=objgroupestudent;
            }
            else
            {
                var objgroupestudent=[]    ;
                itemgroupe.groupestudent.map((it2)=>{
                    if (it2.id_student!=id)objgroupestudent.push(it2);
                })
                itemgroupe.groupestudent=objgroupestudent;
            }
        });
        this.handleSaveGroupe(itemclasse);
    }
    );
    this.setState({must_refresh:true});
}
onDrop = (ev, cat) => {
    
    let id = ev.dataTransfer.getData("id");
    console.log(id);
   var obj=[];
   this.state.classes.map((itemclasse)=>
   {
    if(itemclasse.nom==cat)
    {
       
        this.state.datastudent.map((item)=>{
            if(item.ID==id) {
                if(cat==undefined)item.classe=cat;
                else
                //if(!item.selected  && item.status!="connected") item.classe=cat;
                if(!item.selected)
                {
                    if(!this.IsInClasse(id,cat)) itemclasse.students.push(item);
                }
                else
                {
                    this.state.datastudent.map((item2)=>{
                    //if(item2.selected || item2.status=="connected")item2.classe=cat;
                    if(item2.selected)if(!this.IsInClasse(item2.ID,cat))itemclasse.students.push(item2);
                    if(cat!=undefined)item2.selected=false;
                    })
                }
            }
        
    })
    itemclasse.students.sort((a,b)=>{if(a.nickname.toLowerCase() < b.nickname.toLowerCase()) return -1;
        if(a.nickname.toLowerCase() > b.nickname.toLowerCase()) return 1;
        return 0;}).map((itc)=>obj.push(itc));
    itemclasse.students=[];
    obj.map((itt)=>itemclasse.students.push(itt));
    this.handleSaveClasse(itemclasse);
   }
})
this.setState({must_refresh:true});
}

IsInClasse=(id,nomclasse)=>
{
    var ispresent=0;
    this.state.classes.filter(it=>it.nom==nomclasse).map((item)=>{ispresent=item.students.filter(it2=>it2.ID==id).length;})
    if(ispresent==0)return false
    else return true
}
DeleteAllGroupes=(classeid)=>
{
    var obj=[];
    this.state.classes.map((item)=>
    {
        if(item.ID==classeid)
        {
           item.nb_groupe=0;
           var objgroup=[];
           item.groupe=[];
        }
        obj.push(item);
    });
    this.handleDeleteGroupe(classeid);
    this.setState({classes:obj});
}
GroupesAuto=(classeid)=>
{
    this.state.classes.map((item)=>
    {
        if(item.ID==classeid)
        {
           //item.nb_groupe=0;
           var nb_students=item.students.length;
           var dispa=nb_students/item.nb_groupe;
           dispa=Math.round(dispa);
           var inc=0;
           var incg=0;
           
           item.groupe.map((itemgroupe)=>{
            var objgroupestudent=[];
            for (var i=inc;i<inc+dispa;i++)
               {
                var itemstudent=item.students[i];
                if (itemstudent!=undefined)
                {
                    var st={id_student:itemstudent.ID, nom:itemstudent.nickname};
                    objgroupestudent.push(st);
                }
               }
               itemgroupe.groupestudent=objgroupestudent;
               inc+=dispa;
           })
           this.setState({must_refresh:true});
           this.handleSaveGroupe(item);
        }
        
    });
}

AjouterUnGroupe=(classeid)=>
{
    var obj=[];
    this.state.classes.map((item)=>
    {
        if(item.ID==classeid)
        {
           item.width=item.width+200;
           if(item.nb_groupe==undefined)item.nb_groupe=0;
           item.nb_groupe++;
           var objgroup=[];
           if(item.groupe==undefined)item.groupe=[];
           item.groupe.map((it)=>objgroup.push(it));
           var st={nom:"Groupe "+( item.groupe.length+1),groupestudent:[]}
           item.groupe.push(st);
        }
        obj.push(item);
    });

    this.setState({classes:obj});

}
DeleteFromClasse=(id,nomclasse)=>
{
    var obj=[];
    this.state.classes.map((item)=>
    {
        if(item.nom==nomclasse)
        {
            item.students.map((it)=>{
                if(it.ID!=id)obj.push(it);
            });
            item.students=[];
            obj.map((it2)=>{item.students.push(it2)});
            this.handleSaveClasse(item);

        }
    })
    this.setState({must_refresh:true});
   
}
DeleteClasse=(stclasse)=>
{
    var obj=[];
    this.state.classes.map((item)=>{if(item.nom!=stclasse)obj.push(item);});
    this.state.datastudent.map((item)=>{if(item.classe==stclasse)item.classe=undefined;})
    this.setState({classes:obj});
    this.props.handleDataClasseEtudiants(obj);
    this.handleDeleteClasse(this.state.selected_classe_id);
    this.setState({selected_classe_id:''});
}
AjouterUneClasse=(ev)=>
{
    var obj=[];
    var idd=uniqueId();
    var cl={nom:"Nouvelle Classe "+idd,ID:"new"+idd,width:260,selected:false,visible:true,students:[],groupe:[]};
    obj.push(cl);
    this.state.classes.map((item)=>obj.push(item));
    this.setState({classes:obj});
    this.handleSaveClasse(cl);
    //this.props.handleDataClasseEtudiants(obj);
}
EditerClasse=()=>
{
    var obj=[];
    var nb=0;
    this.state.classes.map((item)=>{if (nb==0) if(item.nom==this.state.selected_classe) {nb++;item.nom=this.state.selected_classe_edit;} obj.push(item);});
    //this.state.datastudent.map((item)=>{if(item.classe==this.state.selected_classe)item.classe=this.state.selected_classe_edit;})
    this.setState({classes:obj});
   //this.props.handleDataClasseEtudiants(obj);
   this.handleSaveClasse(obj.pop());
}
LoadDataClassesForEnseignant=(id)=>
{
  var xhr = new XMLHttpRequest();
  xhr.overrideMimeType("application/json");
  
  var that=this;
  xhr.open('GET','/api/public/getclassesetudiants?id_enseignant='+id);
  
  xhr.setRequestHeader("Content-Type", "application/json");

  //send the form data
  xhr.send();

  xhr.onreadystatechange = function() 
  {
      
     if (xhr.readyState == XMLHttpRequest.DONE) 
     {
                    
        if(xhr.status==200) 
        { 
          var jsonResponse = JSON.parse(xhr.responseText);
          if (jsonResponse != null) 
          {
            //var jj = JSON.parse(jsonResponse[0]);
            console.log("LoadDataClassesForEnseignant");
            console.log(jsonResponse);
            var obj=[];
            
            jsonResponse.map((item)=>{
                var tabstudents=item.id_students.split('_');
                var tab2=[];
                tabstudents.map((it)=>
                {
                    that.state.datastudent.map((it2)=>
                    {
                        if(it2.ID==it)tab2.push(it2);
                    })
                })
                item.selected=false;
                item.visible=true;
                item.students=tab2;
                obj.push(item);
            });
            that.setState({classes:obj});
            that.props.handleDataClasseEtudiants(obj);
            that.setState({must_refresh:true});
            
          }
        }
        if(xhr.status==404) {console.log( {message:"erreur"}); }
        if(xhr.status==500) {console.log( {message:"erreur"}); }
        }
      
      }
}
handlechangenomclasse=(ev)=>{
    this.setState({selected_classe_edit:ev.target.value});
}
handleSaveGroupe=(itemclasse)=>{
    
    itemclasse.groupe.map((itemgroupe)=>{
    var sturl='/api/public/updategroupesetudiants'
    if(itemgroupe.ID==undefined)
    {
        sturl='/api/public/creategroupesetudiants'
        console.log("nouveau groupe a créer:"+ itemgroupe.nom)
        var stid=itemgroupe.nom.split(' ')[1];
        itemgroupe.ID=stid;
    }
   
    var that=this;
    var previd=itemgroupe.ID;
    var xhr = new XMLHttpRequest();
    xhr.overrideMimeType("application/json");
    var formData = new FormData();
    formData.append('nom', itemgroupe.nom);
    formData.append('id_classe', this.state.selected_classe_id);
    formData.append('id_groupe', itemgroupe.ID);
    //formData.append('id_enseignant', this.props.userid);
    var tab="_";
    var itemg=itemgroupe;
    itemgroupe.groupestudent.map((it)=>tab+=it.id_student+"_");
    formData.append('id_students', tab);

    xhr.open('POST',sturl)
    xhr.setRequestHeader("Content-Type", "application/json");

    //send the form data
    xhr.send(JSON.stringify(Object.fromEntries(formData)));

    xhr.onreadystatechange = function() {
        if (xhr.readyState == XMLHttpRequest.DONE) {
        
         if(xhr.status==200) 
         { 
           //var jsonResponse = JSON.parse(xhr.responseText);
           var id=xhr.responseText;
           itemg.ID=id;
           //that.state.classes.filter(it=>it.id==previd).map((item)=>{item.id=id;})
           that.setState({must_refresh:true});
           //that.toaster.show( {icon:"info-sign", intent:Intent.SUCCESS,timeout:2000,message:"La classe est sauvegardée"}); 
           that.props.handleCardEleves("1","");
         } 
        
        // if(xhr.status==500) that.toaster.show( {icon:"info-sign", intent:Intent.SUCCESS,timeout:2000,message:"La classe est sauvegardée"}); }
        
        }
       
    }
    });
    
}
handleSaveClasse=(itemclasse)=>{
    var sturl='/api/public/updateclassesetudiants'
    if(typeof itemclasse.ID=="string")
    {
        sturl='/api/public/createclassesetudiants'
        console.log("nouvelle classe a créer:"+ itemclasse.nom)
    }
    itemclasse.students.map((item)=>
    {
        console.log(item);
    });
    var that=this;
    var previd=itemclasse.ID;
    var xhr = new XMLHttpRequest();
    xhr.overrideMimeType("application/json");
    var formData = new FormData();
    formData.append('nom', itemclasse.nom);
    formData.append('id_classe', itemclasse.ID);
    formData.append('id_enseignant', this.props.userid);
    var tab="_";
    itemclasse.students.map((it)=>tab+=it.ID+"_");
    formData.append('id_students', tab);

    xhr.open('POST',sturl)
    xhr.setRequestHeader("Content-Type", "application/json");

    //send the form data
    xhr.send(JSON.stringify(Object.fromEntries(formData)));

    xhr.onreadystatechange = function() {
        if (xhr.readyState == XMLHttpRequest.DONE) {
        
         if(xhr.status==200) 
         { 
           //var jsonResponse = JSON.parse(xhr.responseText);
           var id=xhr.responseText;
           that.state.classes.filter(it=>it.id==previd).map((item)=>{item.id=id;})
           that.setState({must_refresh:true});
           that.LoadDataClassesForEnseignant(that.props.userid);
           //that.toaster.show( {icon:"info-sign", intent:Intent.SUCCESS,timeout:2000,message:"La classe est sauvegardée"}); 
           that.props.handleCardEleves("1","");
         } 
        
        // if(xhr.status==500) that.toaster.show( {icon:"info-sign", intent:Intent.SUCCESS,timeout:2000,message:"La classe est sauvegardée"}); }
        
        }
       
    }
    
}
handleDeleteClasse=(id)=>{
    this.state.classes.map((item)=>{
        if(item.selected==undefined)item.selected=false;
        if(item.ID==id){item.selected=false;item.visible=true;}
        else  {item.visible=true;item.selected=false;};
        this.setState({must_refresh:true});
    })
    if(typeof id=="string")return;
    var sturl='/api/public/deleteclassesetudiants?id_classe='+id
    var xhr = new XMLHttpRequest();
    xhr.overrideMimeType("application/json");
    var formData = new FormData();
    var that=this;
    xhr.open('GET',sturl)
    xhr.setRequestHeader("Content-Type", "application/json");

    //send the form data
    xhr.send(JSON.stringify(Object.fromEntries(formData)));

    xhr.onreadystatechange = function() {
        if (xhr.readyState == XMLHttpRequest.DONE) {
        
         if(xhr.status==200) 
         { 
           that.props.handleCardEleves("3","");
         } 
        
        // if(xhr.status==500) that.toaster.show( {icon:"info-sign", intent:Intent.SUCCESS,timeout:2000,message:"La classe est sauvegardée"}); }
        
        }
       
    }
    
}
handleDeleteGroupe=(id)=>{
    
    if(typeof id=="string")return;
    var sturl='/api/public/deleteallgroupesetudiants?id_classe='+id
    var xhr = new XMLHttpRequest();
    xhr.overrideMimeType("application/json");
    var formData = new FormData();
    var that=this;
    xhr.open('GET',sturl)
    xhr.setRequestHeader("Content-Type", "application/json");

    //send the form data
    xhr.send(JSON.stringify(Object.fromEntries(formData)));

    xhr.onreadystatechange = function() {
        if (xhr.readyState == XMLHttpRequest.DONE) {
        
         if(xhr.status==200) 
         { 
           //that.props.handleCardEleves("3","");
         } 
        
        // if(xhr.status==500) that.toaster.show( {icon:"info-sign", intent:Intent.SUCCESS,timeout:2000,message:"La classe est sauvegardée"}); }
        
        }
       
    }
    
}
MettreEnIntercom=(etat)=>
{
       this.setState({intercommunication:etat})
}
MettreEnEcouteDiscrete=(etat)=>
{
        this.setState({ecoutediscrete:etat})
}
MettreEnConference=(id,etat,groupe_nom,objconference)=>{
   
    var sturl='api/public/getmesgroupes?id_classe='+id;
    axios.get(sturl, {
        headers: {
          "Content-Type": "application/json"
        },
        responseType: "json"
      })
        .then(response => {
         
          console.log(response.data);
          var jsonResponse=response.data;
          jsonResponse.map((itemgroupe)=>{
            var obj=[];
            this.state.classes.map((item)=>
            {
                if(item.ID==this.state.selected_classe_id)
                {
                    var objgroup=[];
                    var groupestudents="";
                    if(itemgroupe.nom==groupe_nom)
                    {
                    objgroup=itemgroupe.id_students.split('_');
                    objgroup.map((it)=>{
                        if(it!="")groupestudents=it+","+groupestudents;
                    });
                    //if(objconference.tabid==undefined)objconference.tabid=[];
                    var isexist=false;
                    var  objtabid=[];
                    objconference.selected=etat;
                    if(objconference.objtabid!=undefined)objconference.objtabid.map((iij)=>objtabid.push(iij));
                    objtabid.map((ii)=>{if(ii.nom_groupe==itemgroupe.nom)isexist=true})
                    if(!isexist){objtabid.push({nom_groupe:itemgroupe.nom,ID:itemgroupe.ID});}
                    //objconference.tabid[itemgroupe.nom]=itemgroupe.ID;
                    objconference.objtabid=objtabid;
                    this.setState({conference:objconference})
                    groupestudents=groupestudents+itemgroupe.ID;
                    if(etat)
                        this.props.handleOpenVisio(MSG_VISIO.GROUPE_IN_VISIO,"",groupestudents);
                    else
                        this.props.handleOpenVisio(MSG_VISIO.GROUPE_OUT_VISIO,"",groupestudents);
                    }
                    if(groupe_nom=="all")
                    {
                        objgroup=itemgroupe.id_students.split('_');
                        objgroup.map((it)=>{
                            if(it!="")groupestudents=it+","+groupestudents;
                        });
                        var isexist=false;
                        objconference.selected=etat;
                        var  objtabid=[];
                        if(objconference.objtabid!=undefined)objconference.objtabid.map((iij)=>objtabid.push(iij));
                        objtabid.map((ii)=>{if(ii.nom_groupe==itemgroupe.nom)isexist=true})
                        if(!isexist){objtabid.push({nom_groupe:itemgroupe.nom,ID:itemgroupe.ID});}
                        //objconference.tabid[itemgroupe.nom]=itemgroupe.ID;
                        objconference.objtabid=objtabid;
                        this.setState({conference:objconference})
                        groupestudents=groupestudents+itemgroupe.ID;
                        if(etat)
                            this.props.handleOpenVisio(MSG_VISIO.GROUPE_IN_VISIO,"",groupestudents);
                        else
                            this.props.handleOpenVisio(MSG_VISIO.GROUPE_OUT_VISIO,"",groupestudents);
                    }
                }
               //obj.push(item);
            });  
          
        })
        })
        .catch(err => {
          console.log("error", err);
        });  
}
isActif=(obj_fonction,groupe_nom)=>{
    var ret=false
    obj_fonction.groupes.map((it)=>
    {
      if(it==groupe_nom) ret=true;
    });
    return ret;
  }

  getIdGroupe=(obj_fonction,groupe_nom)=>{
    var ret=-1;
    //var tabid=obj_fonction.tabid;
    //obj_fonction.groupes.map((it)=>
    if(obj_fonction.objtabid==undefined)return -1;
    obj_fonction.objtabid.map((it)=>
    {
      if(it.nom_groupe==groupe_nom) ret=it.ID;
    });
    return ret;
  }
MettreEnMosaique=(id,etat,groupe_nom,objmosaique)=>{
    var sturl='api/public/getmesgroupes?id_classe='+id;
    axios.get(sturl, {
        headers: {
          "Content-Type": "application/json"
        },
        responseType: "json"
      })
        .then(response => {
         
          console.log(response.data);
          var jsonResponse=response.data;
          jsonResponse.map((itemgroupe)=>{
            var obj=[];
            this.state.classes.map((item)=>
            {
                if(item.ID==this.state.selected_classe_id)
                {
                    var objgroup=[];
                    var groupestudents="";
                    var params="";
                    var nbr=0;
                    if(itemgroupe.nom==groupe_nom)
                    {
                        objgroup=itemgroupe.id_students.split('_');
                        objgroup.map((it)=>{
                            if(it!="")
                            {
                               // groupestudents=it+","+groupestudents;
                                item.students.map((itemc)=>{
                                    if(itemc.ID==it)
                                    {
                                        if(itemc.iplocal!="")
                                        {
                                            nbr++;
                                            params=params+"ip"+nbr+"="+itemc.iplocal+"&name"+nbr+"="+itemc.nickname+"&";
                                        }
                                    }
                                });
                            }
                        });
                       
                       // groupestudents=groupestudents+itemgroupe.ID;
                        objmosaique.selected=etat;
                        this.setState({mosaique:objmosaique});
                        if (nbr==0)return;
                        params=params+"&nbre="+nbr;
                        if(etat)
                            fenetreOuvertemosaique=window.open("http://164.132.43.81/wb/mosaique.html?"+params,"_blank");
                        else
                            fenetreOuvertemosaique.close();
                    }
                    if(groupe_nom=="all")
                    {
                        objgroup=itemgroupe.id_students.split('_');
                        objgroup.map((it)=>{
                            if(it!="")
                            {
                                item.students.map((itemc)=>{
                                    if(itemc.ID==it)
                                    {
                                        if(itemc.iplocal!="")
                                        {
                                            nbr++;
                                            params=params+"ip"+nbr+"="+itemc.iplocal+"&name"+nbr+"="+itemc.nickname+"&";
                                        }
                                    }
                                });
                            }
                        });
                       // groupestudents=groupestudents+itemgroupe.ID;
                        objmosaique.selected=etat;
                        this.setState({mosaique:objmosaique});
                        if(etat)
                            fenetreOuvertemosaique=window.open("http://164.132.43.81/wb/mosaique.html?"+params,"_blank");
                        else
                        {
                            fenetreOuvertemosaique.close();
                        }
                           // this.props.handleOpenVisio(MSG_VISIO.GROUPE_OUT_RECORD,"",groupestudents);
                    }
                }
               //obj.push(item);
            });  
          
        })
       })
        .catch(err => {
          console.log("error", err);
        });  
}
MettreEnEnregistrement=(id,etat,groupe_nom,objrecordaudio)=>{
    var sturl='api/public/getmesgroupes?id_classe='+id;
    axios.get(sturl, {
        headers: {
          "Content-Type": "application/json"
        },
        responseType: "json"
      })
        .then(response => {
         
          console.log(response.data);
          var jsonResponse=response.data;
          jsonResponse.map((itemgroupe)=>{
            var obj=[];
            this.state.classes.map((item)=>
            {
                if(item.ID==this.state.selected_classe_id)
                {
                    var objgroup=[];
                    var groupestudents="";
                    if(itemgroupe.nom==groupe_nom)
                    {
                        objgroup=itemgroupe.id_students.split('_');
                        objgroup.map((it)=>{
                            if(it!="")groupestudents=it+","+groupestudents;
                        });
                        groupestudents=groupestudents+itemgroupe.ID;
                        objrecordaudio.selected=etat;
                        this.setState({recordaudio:objrecordaudio});
                        if(etat)
                            this.props.handleOpenVisio(MSG_VISIO.GROUPE_IN_RECORD,"",groupestudents);
                        else
                            this.props.handleOpenVisio(MSG_VISIO.GROUPE_OUT_RECORD,"",groupestudents);
                    }
                    if(groupe_nom=="all")
                    {
                        objgroup=itemgroupe.id_students.split('_');
                        objgroup.map((it)=>{
                            if(it!="")groupestudents=it+","+groupestudents;
                        });
                        groupestudents=groupestudents+itemgroupe.ID;
                        objrecordaudio.selected=etat;
                        this.setState({recordaudio:objrecordaudio});
                        if(etat)
                            this.props.handleOpenVisio(MSG_VISIO.GROUPE_IN_RECORD,"",groupestudents);
                        else
                            this.props.handleOpenVisio(MSG_VISIO.GROUPE_OUT_RECORD,"",groupestudents);
                    }
                }
               //obj.push(item);
            });  
          
        })
       })
        .catch(err => {
          console.log("error", err);
        });  
}

LoadDataGroupesForEtudiant=(id)=>
{
  var xhr = new XMLHttpRequest();
  var that=this;
  xhr.overrideMimeType("application/json");
  
  xhr.open('GET','api/public/getmesgroupes?id_classe='+id);
  
  xhr.setRequestHeader("Content-Type", "application/json");

  xhr.send();

  xhr.onreadystatechange = function() 
  {
      
     if (xhr.readyState == XMLHttpRequest.DONE) 
     {
                    
        if(xhr.status==200) 
        { 
            that.state.classes.map((item)=>
            {
                if(item.ID!=that.state.selected_classe_id)
                {
                    //pour les etudiants se déconnectent au prof
                    var id_enseignant=that.props.userid;
                    var id_matiere=-1;
                    var students="";
                    item.students.map((itt)=>{
                        students=itt.ID+","+students;
                    });
                    //if(id_matiere<0)id_enseignant=-1;
                    students=students+id_matiere+","+id_enseignant;
                    //si etudiant dans plusieurs classes voir autrement
                   that.props.handleOpenVisio(MSG_VISIO.GROUPE_OUT_MATIERE,"",students);
                }
            });
            that.state.classes.map((item)=>
            {
                if(item.ID==that.state.selected_classe_id)
                {
                    //pour les etudiants se connectent au prof
                    var id_enseignant=that.props.userid;
                    var id_matiere=that.state.select_matiere_id;
                    var students="";
                    item.students.map((itt)=>{
                        students=itt.ID+","+students;
                    });
                    //if(id_matiere<0)id_enseignant=-1;
                    students=students+id_matiere+","+id_enseignant;
                    that.props.handleOpenVisio(MSG_VISIO.GROUPE_IN_MATIERE,"",students);
                }
               
            });

          var jsonResponse = JSON.parse(xhr.responseText);
          if (jsonResponse != null) 
          {
            //var jj = JSON.parse(jsonResponse[0]);
            console.log("LoadDataGroupesForEtudiant");
            console.log(jsonResponse);
            var obj=[];
            jsonResponse.map((itemgroupe)=>{
                var obj=[];
                that.state.classes.map((item)=>
                {
                    if(item.ID==that.state.selected_classe_id)
                    {
                        item.groupe=[];
                        item.nb_groupe=0;
                    }
                })
            });
            jsonResponse.map((itemgroupe)=>{
                var obj=[];
                that.state.classes.map((item)=>
                {
                    if(item.ID==that.state.selected_classe_id)
                    {
                        item.width=item.width+200;
                        if(item.nb_groupe==undefined)item.nb_groupe=0;
                        item.nb_groupe++;
                        var objgroup=[];
                        if(item.groupe==undefined)item.groupe=[];
                        item.groupe.map((it)=>objgroup.push(it));
                        var groupestudents=itemgroupe.id_students.split('_');
                        var _groupesstudent=[];
                        groupestudents.map((it)=>
                        {
                            if (it!="")
                            {
                                var id=it;
                                var stnomstudent="";
                                that.state.datastudent.map((itemstudent)=>
                                {
                                    if(itemstudent.ID==id) stnomstudent=itemstudent.nickname;
                                });
                                var st={id_student:id, nom:stnomstudent};
                                _groupesstudent.push(st);
                            }
                        });
                        var st={nom:itemgroupe.nom,groupestudent:_groupesstudent}
                        item.groupe.push(st);

                        //pour les etudiants se connectent au prof
                        /*var id_enseignant=that.props.userid;
                        var id_matiere=1;
                        var students="";
                        item.students.map((itt)=>{
                            students=itt.ID+","+students;
                        });
                        //if(id_matiere<0)id_enseignant=-1;
                        students=students+id_matiere+","+id_enseignant;
                        that.props.handleOpenVisio(MSG_VISIO.GROUPE_IN_MATIERE,"",students);*/
                    }
                   //obj.push(item);
                });  
            //var stuser="_"+id+"_";
              //if(itemclasse.id_students.includes(stuser))obj.push(itemclasse);
            });
            that.setState({must_refresh:true});
            //setDataClassesEtudiants(obj);
          }
        }
        if(xhr.status==404) {console.log( {message:"erreur"}); }
        if(xhr.status==500) {console.log( {message:"erreur"}); }
        }
      
      }
}
ForcerMatiere=(id,id_matiere)=>{
    this.setState({select_matiere_id:id_matiere});
    var sturl='api/public/getmesgroupes?id_classe='+id;
    axios.get(sturl, {
        headers: {
          "Content-Type": "application/json"
        },
        responseType: "json"
      })
        .then(response => {
         
          console.log(response.data);
          var jsonResponse=response.data;
          if(jsonResponse.length>0)
          {
          jsonResponse.map((itemgroupe)=>{
            //var obj=[];
            this.state.classes.map((item)=>
            {
                if(item.ID==this.state.selected_classe_id)
                {
                    var objgroup=[];
                    var groupestudents="";
                    objgroup=itemgroupe.id_students.split('_');
                    objgroup.map((it)=>{
                        if(it!="")groupestudents=it+","+groupestudents;
                    });
                    var id_enseignant=this.props.userid;
                    if(id_matiere<0)id_enseignant=-1;
                    groupestudents=groupestudents+id_matiere+","+id_enseignant;
                    if(id_matiere>0)
                        this.props.handleOpenVisio(MSG_VISIO.GROUPE_IN_MATIERE,"",groupestudents);
                    else
                        this.props.handleOpenVisio(MSG_VISIO.GROUPE_OUT_MATIERE,"",groupestudents);
                   
                }
               //obj.push(item);
            });  
           })
          }
          else
          {
            this.state.classes.map((item)=>
            {
                if(item.ID==this.state.selected_classe_id)
                {
                    var objgroup=[];
                    var groupestudents="";
                    objgroup=item.id_students.split('_');;
                    objgroup.map((it)=>{
                        if(it!="")groupestudents=it+","+groupestudents;
                    });
                    var id_enseignant=this.props.userid;
                    if(id_matiere<0)id_enseignant=-1;
                    groupestudents=groupestudents+id_matiere+","+id_enseignant;
                    if(id_matiere>0)
                        this.props.handleOpenVisio(MSG_VISIO.GROUPE_IN_MATIERE,"",groupestudents);
                    else
                        this.props.handleOpenVisio(MSG_VISIO.GROUPE_OUT_MATIERE,"",groupestudents);
                   
                }
               //obj.push(item);
            });
          }
        })
        .catch(err => {
          console.log("error", err);
        });
   // });    
}
refreshClasse=()=>
{
    this.props.LoadDataUserForEnseignant(this.props.userid);
}
handlePublicChange=(itemclasse)=>
{
    
    if(itemclasse.selected==undefined)itemclasse.selected=false;
    var bb=itemclasse.selected;
    
    if(bb==false){this.setState({selected_classe_id:itemclasse.ID});localStorage.setItem("selected_classe_id",itemclasse.ID.toString());this.LoadDataGroupesForEtudiant(itemclasse.ID);}
    else {this.setState({selected_classe_id:""});localStorage.setItem("selected_classe_id","");}
    this.state.classes.map((item)=>{
        if(item.selected==undefined)item.selected=false;
        if(item.ID==itemclasse.ID){item.selected=!item.selected;item.visible=true;}
        else  {item.visible=bb;item.selected=false;};
        console.log(item)
        this.setState({must_refresh:true});
    })
}

SetEnIntercom=(id,etat)=>
{
    this.state.classes.map((item)=>
    {
        if(item.ID==this.state.selected_classe_id)
        {
            //pour les etudiants se connectent au prof
            var id_enseignant=this.props.userid;
            var id_matiere=this.state.select_matiere_id;
            var students="";
            /*item.students.map((itt)=>{
                students=itt.ID+","+students;
            });*/
            students=id+","+id_enseignant;
            if(etat)
            {
                this.props.handleOpenVisio(MSG_VISIO.GROUPE_IN_VISIO,"",students);
                this.props.handleOpenVisio(MSG_VISIO.OUVRIR_CONFERENCE,"",id_enseignant);
            }  
            else
            {
                this.props.handleOpenVisio(MSG_VISIO.GROUPE_OUT_VISIO,"",students);
                this.props.handleOpenVisio(MSG_VISIO.FERMER_CONFERENCE,"",id_enseignant);
            }
        }
       
    });
}
   render() {
    
    const {nom_student,handleOpenVisio,handleSelectPage}=this.props;
    
    return(
     <div style={{position:'relative',zIndex:10}}>
        {this.state.selected_classe_id!="" && this.props.pageid=="mesetudiantslabo"?<Card style={{margin: 4,backgroundColor: 'rgb(228, 239, 247)', padding: '10px 10px 0 10px'}}  interactive={false} elevation={Elevation.TWO}>
        <Button  intent={!this.state.isSelectMatiere?Intent.SUCCESS:Intent.DANGER} style={{userSelect: 'none',marginBottom:15,marginLeft:4}} icon="manual"
        onClick={(ev)=>{ev.preventDefault();this.setState({isSelectMatiere:!this.state.isSelectMatiere});this.setState({isvisibleenregistrements:false});this.setState({isvisiblegroupes:false});this.setState({isvisiomagistrale:false});}}>Choisir une matière</Button>
        <Button disabled={false} intent={!this.state.isvisibleindividuel?Intent.SUCCESS:Intent.DANGER} onClick={(ev)=>{this.setState({isSelectMatiere:false});this.setState({isvisibleenregistrements:false});this.setState({isvisiblegroupes:false});this.setState({isvisibleindividuel:!this.state.isvisibleindividuel});this.refreshClasse();}} style={{marginBottom:15,marginLeft:4}} icon="flow-review" title="Fonctions individuelles" >Individuel</Button>
        <Button disabled={this.state.isvisiomagistrale} intent={!this.state.isvisiblegroupes?Intent.SUCCESS:Intent.DANGER} onClick={(ev)=>{this.setState({isSelectMatiere:false});this.setState({isvisibleenregistrements:false});this.setState({isvisiblegroupes:!this.state.isvisiblegroupes});this.setState({isvisibleindividuel:false});this.setState({isvisiomagistrale:false});}} style={{marginBottom:15,marginLeft:4}} icon="inherited-group"  title="Gérer vos groupes" >Groupes</Button>
        <Button intent={!this.state.isvisibleenregistrements?Intent.SUCCESS:Intent.DANGER} onClick={(ev)=>{this.setState({isSelectMatiere:false});this.setState({isvisibleenregistrements:!this.state.isvisibleenregistrements});this.setState({isvisiblegroupes:false});this.setState({isvisiomagistrale:false});this.setState({isvisibleindividuel:false});}} style={{marginBottom:15,marginLeft:4}} icon="rotate-document" title="Enregistrement de mes étudiants" >Documents des étudiants</Button>
        <Button disabled={this.state.isvisiblegroupes} intent={!this.state.isvisiomagistrale?Intent.SUCCESS:Intent.DANGER} onClick={(ev)=>{this.setState({isSelectMatiere:false});this.setState({isvisibleenregistrements:false});this.setState({isvisiblegroupes:false});this.setState({isvisiomagistrale:!this.state.isvisiomagistrale});this.setState({isvisibleindividuel:false});}} style={{marginBottom:15,marginLeft:4}} icon="flow-branch" title="Parler à tous vos élèves" >Visio Magistrale</Button>
        </Card>:null}
     <div style={{paddingTop:'0px',position:'relative',display:'flex',zIndex:10,width:'100%'}}>
     {this.props.pageid=="mesetudiants"?
     <Card onDrop={(e)=>this.onDrop(e, undefined)} onDragOver={(e)=>this.onDragOver(e)} style={{minWidth:300,width:300,margin:4,backgroundColor:'#e4eff7',padding: '10px'} } interactive={false} elevation={Elevation.TWO}>
     <H4>Liste de vos étudiants<Icon onClick={(ev)=>{this.setState({isOpenHelp:true})}} icon="help" size={22} intent={Intent.PRIMARY} style={{marginLeft:60}}></Icon></H4>
     <Button intent={Intent.PRIMARY} style={{userSelect: 'none', marginLeft: 60,marginBottom:10,padding: 10}} icon="plus" onClick={(ev)=>{ev.preventDefault();this.AjouterUneClasse(ev);}}>Ajouter une classe</Button>
     <Button intent={Intent.PRIMARY} style={{userSelect: 'none', marginLeft: 73,padding: 10}} icon="refresh" onClick={(ev)=>{ev.preventDefault();this.refreshClasse();}}>Rafraichir liste</Button>
        <ul>
            {this.state.datastudent.map((item, idx) => (
            //item.classe==undefined?
            <div id={item.ID} onClick={(ev)=>{ev.preventDefault();item.selected=!item.selected;this.setState({must_refresh:true});}}  onDragStart = {(e) => this.onDragStart(e, item.ID)} draggable style={{backgroundColor: item.etat=="En ligne" ?'#fff':"#ccc",margin:'3px',padding: '10px 5px',textAlign: 'left',width: '200px',borderRadius: '10px',boxShadow: '1px 1px 1px #ccc'}}><Checkbox  key={idx} checked={item.selected} ></Checkbox><span>{item.nickname}</span></div>))}
            {/*this.state.selected_student.map((item, idx) => (
              <div style={{height: item.etat=="En ligne"?'30px':'0px'}}>{item ? item.etat=="En ligne"?<span ><Checkbox  key={idx} checked={item.selected} onClick={(ev)=>{item.selected=!item.selected;console.log(item);this.setState({must_refresh:true});}} ></Checkbox><span><b>{item.nickname}</b>:  est en ligne</span></span>:null:null}</div>
            ))*/}
          </ul>
     </Card>:null}
     {this.props.pageid=="mesetudiantslabo"?this.state.classes.length==0?<Card><H4>Vous n'avez pas créé de classe</H4><p>Vous devez créer au moins une classe pour accéder aux fonctions du labo.<br/>Pour créer une classe choisissez dans le menu le bouton "Gestion" et ensuite "Mes étudiants"</p></Card>:null:null}
     {this.state.classes.map((itemclasse)=>(
     itemclasse.visible?<Card onDrop={(e)=>this.onDrop(e, itemclasse.nom)} onDragOver={(e)=>this.onDragOver(e)} style={{width:itemclasse.width,minWidth: 240}} interactive={false}>
         <H4>{itemclasse.nom}</H4><Switch checked={itemclasse.selected} label="Selection" onChange={(ev)=>this.handlePublicChange(itemclasse)} />
         <Button onClick={(ev)=>{this.setState({selected_classe:itemclasse.nom});this.setState({selected_classe_edit:itemclasse.nom});this.setState({isedit:true});}} style={{marginBottom:15}} icon="edit" intent={Intent.PRIMARY} ></Button>
         <Button onClick={(ev)=>{this.handleSaveClasse(itemclasse);}} style={{marginBottom:15,marginLeft:4}} icon="floppy-disk" intent={Intent.WARNING} ></Button>
         <Button onClick={(ev)=>{this.setState({selected_classe:itemclasse.nom});this.setState({selected_classe_id:itemclasse.ID});this.setState({isconfirmdeleteclasse:true});}} style={{marginBottom:15,marginLeft:4}} icon="trash" intent={Intent.DANGER} ></Button>
          
         
         <div style={{display:'flex',marginTop:10}}>
         <div  style={{width:'160px',backgroundColor:'#FFF',borderRadius:'10px',padding:5}}>
          {itemclasse.students.map((item, idx) => (
          //item.classe==itemclasse.nom?
            <div id={item.ID}  onDragStart = {(e) => this.onDragStart(e, item.ID)} draggable style={{backgroundColor: item.etat=="En ligne" ?'#fff':"#ccc",margin:'3px',padding: 15,textAlign: 'left',width: '200px',borderRadius: '10px',boxShadow: '1px 1px 4px #ccc'}}>
                {this.props.pageid=="mesetudiants"?<span><Button style={{marginRight:5}} key={idx} icon='trash'title="Supprimer l'élève de cette classe" onClick={(ev)=>this.DeleteFromClasse(item.ID,itemclasse.nom)} ></Button><Button style={{marginRight:5}} icon='eraser'title="effacer son mot de passe" onClick={(ev)=>this.setState({eleve_seleted_toerase_pwd:item.ID})}></Button></span>
                :this.state.isvisibleenregistrements?<Button intent={this.state.eleve_selected_todocument==item.ID?Intent.DANGER:Intent.PRIMARY} onClick={(ev)=>{if(this.state.eleve_selected_todocument==item.ID)this.setState({eleve_selected_todocument:-1}); else this.setState({eleve_selected_todocument:item.ID});}} style={{marginRight:5}} title="Voir les documents de cet étudiant" icon="rotate-document" ></Button>
                :this.state.intercommunication?<div><Button intent={this.state.eleve_selected_intercommunication==item.ID?Intent.DANGER:Intent.PRIMARY} onClick={(ev)=>{if(this.state.eleve_selected_intercommunication==item.ID){this.SetEnIntercom(item.ID,false);this.setState({eleve_selected_intercommunication:-1});} else {this.SetEnIntercom(item.ID,true);this.setState({eleve_selected_intercommunication:item.ID});}}} style={{marginRight:5}} title="Dialoguer avec l'étudiant" icon="headset" ></Button>
                {item.iplocal!=""?<Button intent={this.state.eleve_selected_visuecran==item.iplocal?Intent.DANGER:Intent.PRIMARY} onClick={(ev)=>{if(this.state.eleve_selected_visuecran==item.iplocal){fenetreOuverte.close();this.setState({eleve_selected_visuecran:""});} else {this.setState({eleve_selected_visuecran:item.iplocal});fenetreOuverte=window.open("http://164.132.43.81/wb/?ip="+item.iplocal+"&name="+item.nickname+"&priseenmain=true","_blank");}}} style={{marginRight:5}} title="prendre en main à distance l'écran de l'étudiant" icon="desktop" ></Button>:null}</div>
                :this.state.ecoutediscrete?<div><Button intent={this.state.eleve_selected_ecoutediscrete==item.ID?Intent.DANGER:Intent.PRIMARY} onClick={(ev)=>{if(this.state.eleve_selected_ecoutediscrete==item.ID)this.setState({eleve_selected_ecoutediscrete:-1}); else this.setState({eleve_selected_ecoutediscrete:item.ID});}} style={{marginRight:5}} title="Ecouter l'étudiant l'étudiant" icon="flow-linear" ></Button>
                {item.iplocal!=""?<Button intent={this.state.eleve_selected_visuecran==item.iplocal?Intent.DANGER:Intent.PRIMARY} onClick={(ev)=>{if(this.state.eleve_selected_visuecran==item.iplocal){fenetreOuverte.close();this.setState({eleve_selected_visuecran:""});} else {this.setState({eleve_selected_visuecran:item.iplocal});fenetreOuverte=window.open("http://164.132.43.81/wb/?ip="+item.iplocal+"&name="+item.nickname,"_blank");}}} style={{marginRight:5}} title="voir l'écran de l'étudiant" icon="desktop" ></Button>:null}</div>
                :null}
                <span>{item.nickname}</span></div>))}
          </div>
          <div style={{display:'flex',flexWrap: 'wrap',marginLeft:60}}>
          {/*itemclasse.groupe!=undefined ? itemclasse.groupe.map((itemgroup,idx)=><Card style={{width:180,minWidth:180, margin:'10px 5px 5px 5px'}}>{itemgroup.nom}</Card>):null*/}
          </div>
          </div>
          
     </Card>:null))}

     {this.state.selected_classe_id!="" && this.props.pageid=="mesetudiantslabo"? this.state.isvisibleenregistrements ||this.state.isvisiblegroupes || this.state.isvisiomagistrale || this.state.isSelectMatiere ?<Card  interactive={false} elevation={Elevation.TWO} style={{minWidth:440}}>
     
     <div style={{display:'flex',marginTop:10}}>
     {this.state.isSelectMatiere?<CardForceMatiere ForcerMatiere={this.ForcerMatiere} datamatieres={this.state.datamatieres} selected_classe_item={this.state.classes.filter(it=>it.ID==this.state.selected_classe_id)} selected_classe_id={this.state.selected_classe_id}/>:null}
     {this.state.isvisiomagistrale?<CardVisioMagistrale nb_student_cnx={this.state.nb_student} frameurl={this.props.frameurl} handleOpenVisio={this.props.handleOpenVisio} {...this.state} />:null}
     {this.state.isvisibleenregistrements?<CardMesEnregistrementsEnseignants _onUploadtext={this.props._onUploadtext} eleve_selected_todocument={this.state.eleve_selected_todocument} students={this.state.datastudent} userid={this.props.userid} id_classe={this.state.selected_classe_id} />:null}
     {this.state.isvisiblegroupes?
         <div>
         <div style={{marginLeft:0,paddingBottom:25,marginTop: -15,userSelect: 'none'}}><Icon onClick={(ev)=>{this.setState({isOpenHelpGroupe:true})}} icon="help" size={22} intent={Intent.PRIMARY} style={{marginRight:10}}></Icon><a>Aide</a></div>
         <a style={{marginTop: -21,position: 'absolute'}}>{this.state.classes.filter(it=>it.ID==this.state.selected_classe_id).map((itemc)=>{if(itemc.nb_groupe==undefined)itemc.nb_groupe=0; return(itemc.nb_groupe)})} groupes</a>
         <Button intent={Intent.PRIMARY} style={{userSelect: 'none', margin: '0 0 10px 0',padding: 1}} icon="plus" onClick={(ev)=>{ev.preventDefault();this.AjouterUnGroupe(this.state.selected_classe_id);}}></Button>
         {/*this.state.classes.filter(it=>it.ID==this.state.selected_classe_id).map((itemc)=>itemc.nb_groupe>0? <Button onClick={(ev)=>{this.handleSaveGroupe(itemc);}} style={{marginBottom:15,marginLeft:4,marginTop: 5}} icon="floppy-disk" intent={Intent.WARNING} ></Button>:null)*/}
         {this.state.classes.filter(it=>it.ID==this.state.selected_classe_id).map((itemc)=>itemc.nb_groupe>0? <Button intent={Intent.PRIMARY} style={{userSelect: 'none', margin: '0px 5px 10px 6px',padding: '1px 5px'}} icon="trash" title="Effacer tous les groupes" onClick={(ev)=>{ev.preventDefault();this.DeleteAllGroupes(this.state.selected_classe_id);}}></Button>:null)}
         {this.state.classes.filter(it=>it.ID==this.state.selected_classe_id).map((itemc)=>itemc.nb_groupe>0? <Button intent={Intent.PRIMARY} style={{userSelect: 'none', margin: '0px 5px 10px 20px',padding: '1px 5px'}} icon="multi-select" onClick={(ev)=>{ev.preventDefault();this.GroupesAuto(this.state.selected_classe_id);}}>Auto</Button>:null)}
         
         {this.state.classes.filter(it=>it.ID==this.state.selected_classe_id).map((itemc)=>
            {
             
             return(
             
             itemc.groupe!=undefined ?
             itemc.groupe.map( (itemgroup,idx)=><Card style ={{minHeight: 100, width: 400,marginBottom:4}} onDrop={(e)=>this.onDropGroup(e, itemgroup.nom)} onDragOver={(e)=>this.onDragOver(e)} ><b>{itemgroup.nom}</b>
                <Button intent={this.visio_prof[this.getIdGroupe(this.state.conference,itemgroup.nom)]==undefined?Intent.PRIMARY:Intent.DANGER} style={{marginLeft:10}} onClick={(ev)=>{var st=this.getIdGroupe(this.state.conference,itemgroup.nom); if(this.visio_prof[st]==undefined){this.props.handleOpenVisio(MSG_VISIO.OUVRIR_PROF_CONFERENCE,"",st);this.visio_prof=[];this.visio_prof[st]=true;}else{this.props.handleOpenVisio(MSG_VISIO.FERMER_VISIO,"",st);this.visio_prof[st]=undefined;}}} disabled={!this.isActif(this.state.conference,itemgroup.nom)} icon="eye-open" title="Entrer dans la conférence"></Button>
                <div style={{marginTop:5}}>
                {itemgroup.groupestudent.map((itemstudent)=>{
                   return( <div style={{userSelect:'none', marginBottom:2, borderRadius:4,backgroundColor:"#eee",padding:4}}><Button style={{marginRight:5}}icon='trash'title="Supprimer l'élève du groupe" onClick={(ev)=>this.DeleteFromGroupe(itemstudent.id_student)} ></Button>{itemstudent.nom}</div>)
                })}
                </div>
             </Card>)
             :null)
            }
        
         )}
         </div>:null}
     </div>
     </Card>:null:null}
     {this.state.isvisiblegroupes?
     this.state.classes.filter(it=>it.ID==this.state.selected_classe_id).map((itemc)=>itemc.nb_groupe>0? 
     <CardFonctions conference={this.state.conference} recordaudio={this.state.recordaudio} mosaique={this.state.mosaique} handleOpenVisio={this.props.handleOpenVisio} frameurl={this.props.frameurl} ForcerMatiere={this.ForcerMatiere} datamatieres={this.state.datamatieres} selected_classe_item={this.state.classes.filter(it=>it.ID==this.state.selected_classe_id)} selected_classe_id={this.state.selected_classe_id} MettreEnEnregistrement={this.MettreEnEnregistrement} MettreEnConference={this.MettreEnConference} MettreEnMosaique={this.MettreEnMosaique}></CardFonctions>:null)     
     :null}
     {this.state.isvisibleindividuel?
     <CardFonctionsIndividuelles eleve_selected_ecoutediscrete={this.state.eleve_selected_ecoutediscrete} eleve_selected_intercommunication={this.state.eleve_selected_intercommunication} intercommunication={this.state.intercommunication} ecoutediscrete={this.state.ecoutediscrete} handleOpenVisio={this.props.handleOpenVisio} frameurl={this.props.frameurl} ForcerMatiere={this.ForcerMatiere} datamatieres={this.state.datamatieres} selected_classe_item={this.state.classes.filter(it=>it.ID==this.state.selected_classe_id)} selected_classe_id={this.state.selected_classe_id} MettreEnIntercom={this.MettreEnIntercom} MettreEnEcouteDiscrete={this.MettreEnEcouteDiscrete}></CardFonctionsIndividuelles>
     :null}
     
     <Overlay isOpen={this.state.isOpenHelp} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '80px 25%'}}>
                        <H4>Aide sur la création de classe</H4>
                        
                        <p>
                            Les étudiants listés sur un fond blanc sont vos étudiants qui sont en ligne.<br/>
                            Les étudiants listés sur un fond gris, sont vos étudiants qui ont saisis votre code matière, mais ne sont pas en ligne.<br/>
                            Le bouton "Ajouter une classe" vous permet de créer une classe.<br/>
                            Le bouton "Rafraichir liste" vous permet de rafraichir la liste des étudiants qui sont en train de saisir votre code.<br/>
                            Ensuite cliquez-glissez vous étudiants dans la classe.<br/>
                            Astuces:Si vous cliquez-glissez un étudiant en ligne, alors tous les étudiants en lignes seront glissés aussi.<br/>
                            Vous pouvez faire une sélection multiple, et ensuite cliquer-glisser vers la nouvelle classe.<br/>
                            Si votre classe contient plus de deux étudiants, alors vous pourrez créer des groupes.<br/>
                        </p>
                        <p></p>
                      
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isOpenHelp:false})}} style={{ margin: "" }}>
                                Fermer
                            </Button>
                            
                            
                            
                        </div>
                    </div>
        </Overlay>
        <Overlay isOpen={this.state.isOpenHelpGroupe} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '80px 25%'}}>
                        <H4>Aide sur la création des groupes </H4>
                        
                        <p>
                        <div style={{marginBottom:15}}>
                            <Button intent={Intent.PRIMARY} style={{userSelect: 'none', margin: '0 10px 5px 0',padding: 1}} icon="plus"></Button>
                            Cliquez pour ajouter des groupes et ensuite cliquez-glissez vos étudiants dans les groupes
                        </div>
                        <div style={{marginBottom:15}}>
                            <Button intent={Intent.PRIMARY} style={{userSelect: 'none', margin: '0 10px 5px 0',padding: 1}} icon="trash"></Button>
                            Effacer tous les groupes
                        </div>
                        <div style={{marginBottom:15}}>
                            <Button intent={Intent.PRIMARY} style={{userSelect: 'none', margin: '0 10px 5px 0',padding: 1}} icon="multi-select">Auto</Button>
                            Répartition et affectation automatique des étudiants dans les groupes
                        </div>
                        
                        </p>
                        <p></p>
                      
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isOpenHelpGroupe:false})}} style={{ margin: "" }}>
                                Fermer
                            </Button>
                            
                            
                            
                        </div>
                    </div>
        </Overlay>
        <Overlay isOpen={this.state.isconfirmdeleteclasse} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
                        <H4>Effacer la classe {this.state.selected_classe}</H4>
                       
                        <p style={{marginTop:20}}>
                           Etes-vous sûr de vouloir effacer la classe {this.state.selected_classe} ?
                        </p>
                                              
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isconfirmdeleteclasse:false});}}>Annuler</Button>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{
                              ev.preventDefault();this.setState({isconfirmdeleteclasse:false});
                              this.DeleteClasse(this.state.selected_classe);
                              }} style={{ margin: "" }}>
                                Valider
                            </Button>
                            
                            
                        </div>
                    </div>
        </Overlay>
        <Overlay isOpen={this.state.isedit} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
                        <H4>Nom de la classe {this.state.selected_classe}</H4>
                       
                        <p style={{marginTop:20}}>
                           Entrez un nouveau nom pour cette classe
                        </p>
                        <input value={this.state.selected_classe_edit} onChange={(ev)=>{this.handlechangenomclasse(ev);}}></input>        
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isedit:false});}}>Annuler</Button>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{
                              ev.preventDefault();this.setState({isedit:false});
                              this.EditerClasse();
                              }} style={{ margin: "" }}>
                                Valider
                            </Button>
                            
                            
                        </div>
                    </div>
        </Overlay>
        <Overlay isOpen={this.state.eleve_seleted_toerase_pwd>0} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
                        <H4>Effacer le mot de passe d'un étudiant</H4>
                       
                        <p style={{marginTop:20}}>
                           Etes-vous sûr de vouloir effacer le mot de passe de l'étudiant?
                        </p>
                        <p>
                            Si l'étudiant à perdu son mot de passe, en validant, l'étudiant pourra enregistrer un nouveau mot de passe<br/>
                        </p>
                                              
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({eleve_seleted_toerase_pwd:-1});}}>Annuler</Button>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{
                              ev.preventDefault();this.setState({isOpenDelete:false});
                              var that=this;
                              var xhr = new XMLHttpRequest();
                              xhr.overrideMimeType("application/json");
                              var that=this;
                              xhr.open('GET','/api/public/deletepassword?id_user='+this.state.eleve_seleted_toerase_pwd)
                              this.setState({eleve_seleted_toerase_pwd:-1});
                              xhr.setRequestHeader("Content-Type", "application/json");

                              //send the form data
                              xhr.send();

                                    xhr.onreadystatechange = function() {
                                        if (xhr.readyState == XMLHttpRequest.DONE) {
                                                      
                                        if(xhr.status==200) 
                                        { 
                                        
                                          console.log(xhr.responseText);      
                                          that.props.handleCardEleves("2","")                                    
                                        }
                                        if(xhr.status==404) {console.log( {message:"erreur"}); }
                                        if(xhr.status==500) {console.log( {message:"erreur"}); }
                                        
                                        }
                                      
                                    }
                              
                              
                              
                              
                              }} style={{ margin: "" }}>
                                Valider
                            </Button>
                            
                            
                        </div>
                    </div>
     </Overlay>
    
     </div></div>);
}
}
 